module.exports = __webpack_public_path__ + "92324375b5658240ff66ccc4f0cdcb79.svg";